import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditSocioComponent } from './edit/editsocio.component';
import { AddSocioComponent } from './add/addsocio.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

@NgModule({
	imports:[
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
	],
	declarations:[EditSocioComponent,AddSocioComponent],
	entryComponents:[EditSocioComponent,AddSocioComponent],
})
export class ModalSocioModule { }
